import Weather from "./Weather";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <Weather />
    </div>
  );
}
